import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../store/actions/index";
import moment from "moment";

import { SearchOutlined } from "@ant-design/icons";

import { Table, Input, Button, Popconfirm, Tag } from "antd";
import Highlighter from "react-highlight-words";

import Breadcrumb from "../components/Breadcrumb";
import ExportCSV from "../components/Common/ExportCSV";

// const data = this.props.api.userGetData;

class Hmg extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    loading: false,
    visible: false,
    createModalVisible: false,
    updateModalVisible: false,
    updateInitialValue: null,
  };
  async componentDidMount() {
    if (!this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    // if (!this.props.api.indexesGetData) {
    //   await this.props.indexesGet();
    // }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          // placeholder={`Search ${dataIndex}`}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: 8,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters , confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex && text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  createModalShow = () => {
    this.setState({ createModalVisible: true });
  };

  createModalCancel = () => {
    this.setState({ createModalVisible: false });
  };

  createModalCreate = () => {
    const { form } = this.createModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.hmgCreate(values)) {
        form.resetFields();
        await this.props.hmgGet();
        this.setState({ createModalVisible: false });
      }
    });
  };

  createModalFormRefSaveFormRef = (formRef) => {
    this.createModalFormRef = formRef;
  };

  handleEdit = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalShow = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalCancel = () => {
    const { form } = this.updateModalFormRef.props;
    form.resetFields();
    this.setState({ updateModalVisible: false, updateInitialValue: null });
  };

  updateModalCreate = () => {
    const { form } = this.updateModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.hmgUpdate(values)) {
        form.resetFields();
        await this.props.hmgGet();
        this.setState({ updateModalVisible: false });
      }
    });
  };

  updateModalFormRefSaveFormRef = (formRef) => {
    this.updateModalFormRef = formRef;
  };

  hmgDelete = async (value) => {
    console.log(value);

    if (await this.props.deleteItem({ type: "project", _id: value })) {
      await this.props.hmgGet();
    }
  };

  getUpdatedExcelBuffer = (data) => {
    const newData = data.map((i) => {
      const newData2 = { ...i };
      newData2.create_at = i.create_at ? moment(i.create_at).local().format("YYYY-MM-DD HH:mm:ss") : null;
      newData2.update_at = i.update_at ? moment(i.update_at).local().format("YYYY-MM-DD HH:mm:ss") : null;
      return newData2;
    });
    return newData;
  };

  render() {
    let columns = [
      {
        title: "Project Name",
        dataIndex: "project_name",
        key: "project_name",
        width: "200px",
        fixed: "left",
        ...this.getColumnSearchProps("project_name"),
        sorter: (a, b) =>
          a.project_name ? a.project_name.localeCompare(b.project_name) : null,
      },
      {
        title: "ID",
        dataIndex: "_id",
        key: "_id",
        width: "250px",
        ...this.getColumnSearchProps("_id"),
        sorter: (a, b) => (a._id ? a._id.localeCompare(b._id) : null),
      },
      {
        title: "HMG Name",
        dataIndex: "hmg_name",
        key: "hmg_name",

        width: "200px",
        ...this.getColumnSearchProps("hmg_name"),
        sorter: (a, b) =>
          a.hmg_name ? a.hmg_name.localeCompare(b.hmg_name) : null,
      },

      {
        title: "Entity ID",
        dataIndex: "is_entityid",
        key: "is_entityid",
        width: "150px",
        ...this.getColumnSearchProps("is_entityid"),
        sorter: (a, b) => {
          a = a.is_entityid || 0;
          b = b.is_entityid || 0;
          return a - b;
        },
      },
      {
        title: "Project ID",
        dataIndex: "project_id",
        key: "project_id",
        width: "150px",
        ...this.getColumnSearchProps("project_id"),

        sorter: (a, b) => {
          a = a.project_id || 0;
          b = b.project_id || 0;
          return a - b;
        },
      },

      {
        title: "Solutions",
        dataIndex: "solution",
        key: "solution",

        width: "200px",
        ...this.getColumnSearchProps("solution"),
        sorter: (a, b) =>
          a.solution ? a.solution.localeCompare(b.solution) : null,
      },

      {
        title: "Indexs",
        dataIndex: "index_name",
        key: "index_name",
        width: "250px",
        render: (tags) => (
          <span>
            {tags.map((tag) => (
              <Tag
                color="blue"
                key={tag}
                style={{ marginRight: "2px", marginBottom: "2px" }}
              >
                {tag}
              </Tag>
            ))}
          </span>
        ),
      },

      {
        title: "Signature Style",
        dataIndex: "signature_type",
        key: "signature_type",
        width: "200px",
        ...this.getColumnSearchProps("signature_type"),
      },
      {
        title: "Smart Scaning Timed Out",
        dataIndex: "smart_scaning_timed_out",
        key: "smart_scaning_timed_out",
        width: "220px",
        ...this.getColumnSearchProps("smart_scaning_timed_out"),
      },

      // {
      //   title: "V2.2 HMG",
      //   dataIndex: "hmg_22",
      //   key: "hmg_22",
      //   width: "200px",
      //   render: text => {
      //     if (text) {
      //       return (<Tag color="blue" >Enable</Tag>)

      //     }else{
      //       return (<Tag color="red" >Disable</Tag>)
      //     }

      //   },
      //   sorter: (a, b) => {
      //     a = a.hmg_22 ?  0 :  1;
      //     b = b.hmg_22 ? 0 : 1;
      //     return (a - b);
      // }

      // },
      {
        title: "MYP HMG ID",
        dataIndex: "myp_id",
        key: "myp_id",
        width: "200px",
        ...this.getColumnSearchProps("myp_id"),
        sorter: (a, b) => {
          a = a.myp_id || 0;
          b = b.myp_id || 0;
          return a - b;
        },
      },

      {
        title: "Smart Scan",
        dataIndex: "smart_scan_type",
        key: "smart_scan_type",
        width: "200px",
        render: (text) => {
          if (text === "1") {
            return (
              <Tag
                color="blue"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                Yes
              </Tag>
            );
          } else if (text === "0") {
            return (
              <Tag
                color="red"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                No
              </Tag>
            );
          } else {
            return (
              <Tag
                color="red"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                Parent
              </Tag>
            );
          }
        },
        sorter: (a, b) => {
          a = a.smart_scan_type ? a.smart_scan_type : "2";
          b = b.smart_scan_type ? b.smart_scan_type : "2";
          return a.localeCompare(b);
        },
      },

      {
        title: "Created by",
        dataIndex: "create_by",
        key: "create_by",
        width: "200px",
        ...this.getColumnSearchProps("create_by"),
      },
      {
        title: "Created at",
        dataIndex: "create_at",
        key: "create_at",
        width: "200px",
        ...this.getColumnSearchProps("create_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      {
        title: "Updated by",
        dataIndex: "update_by",
        key: "update_by",
        width: "200px",
        ...this.getColumnSearchProps("update_by"),
      },
      {
        title: "Updated at",
        dataIndex: "update_at",
        key: "update_at",
        width: "200px",
        ...this.getColumnSearchProps("update_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },

      // {
      //   title: "Action",
      //   dataIndex: "action",
      //   fixed: "right",
      //   width: "100px",
      //   render: (text, record) => (
      //     <Popconfirm
      //       title="Sure to edit?"
      //       onConfirm={() => this.updateModalShow(record)}
      //     >
      //       <a href="/#">Edit</a>
      //     </Popconfirm>
      //   )
      // }
    ];

    if (this.props.api.permission.sm_hmg_delete) {
      columns.push({
        title: "Action",
        dataIndex: "action",
        // fixed: "right",
        width: "100px",
        render: (text, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => this.hmgDelete(record._id)}
          >
            <Button
              type="default"
              danger
              size="small"
              style={{ paddingLeft: "5px", paddingRight: "5px" }}
            >
              Delete
            </Button>
          </Popconfirm>
        ),
      });
    }

    let tableHeight = 500;
    if (window.innerWidth > 700) {
      tableHeight = window.innerHeight - 300;
    }

    return (
      <div>
        <div className="container_aa">
          <h3>Project Manager</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              { path: "project-manager", breadcrumbName: "Project Manager" },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1 user_manager">
            {/* <div className="container_style_1_a">
              <Button type="primary" onClick={this.createModalShow}>
                Create HMG
              </Button>
            </div> */}
            <div className="container_style_1_b" style={{ width: "100%" }}>
              {this.props.api.hmgGetData ? (
                <div className="is_table_3">
                  <ExportCSV
                    csvData={this.getUpdatedExcelBuffer(this.props.api.hmgGetData.data)}
                    fileName={"project-manager"}
                    columnNames={columns}
                  />
                  <Table
                    className={"sm-custom-column-header"}
                    columns={columns}
                    scroll={{ x: 2720, y: tableHeight }}
                    dataSource={this.props.api.hmgGetData.data}
                    rowKey="_id"
                  />
                </div>
              ) : null}
              {/* {this.props.api.indexesGetData ? (
                <CreateForm
                  wrappedComponentRef={this.createModalFormRefSaveFormRef}
                  visible={this.state.createModalVisible}
                  onCancel={this.createModalCancel}
                  onCreate={this.createModalCreate}
                  indexesGetData={this.props.api.indexesGetData.data}
                />
              ) : null} */}
              {/* {this.props.api.indexesGetData ? (
                <UpdateForm
                  wrappedComponentRef={this.updateModalFormRefSaveFormRef}
                  visible={this.state.updateModalVisible}
                  onCancel={this.updateModalCancel}
                  onCreate={this.updateModalCreate}
                  updateInitialValue={this.state.updateInitialValue}
                  indexesGetData={this.props.api.indexesGetData.data}
                />
              ) : null} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgGet: () => dispatch(actions.hmgGet()),
  indexesGet: () => dispatch(actions.indexesGet()),
  hmgCreate: (data) => dispatch(actions.hmgCreate(data)),
  hmgUpdate: (data) => dispatch(actions.hmgUpdate(data)),
  deleteItem: (data) => dispatch(actions.deleteItem(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hmg);
